import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Select, Space, Card, Typography, Switch, Spin } from "antd";
import {
  CustomButton,
  CustomSecondaryButton,
} from "../../physician_page/styled";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { physicianService } from "../../../../services/user";
import { notify } from "../../../../utils/helper";
import script from "../../../../services/script";
import styled from "styled-components";
import { SpecilityContext } from "../../../../context/SpecilityContext";

const { Option } = Select;
const { Text } = Typography;

const ToggleContainer = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background: var(--primary-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);

  .ant-switch-inner {
    display: block;
    margin: 0px 28px 0px 25px;
    color: var(--primary-text-color);
    font-size: 12px;
    transition: margin 0.2s;
    font-weight: 700;
    font-family: "Inter", sans-serif;
  }

  .toggle-label {
    display: flex;
    align-items: center;
    gap: 8px;

    .ant-typography {
      margin: 0;
      font-weight: 500;
      color: var(--primary-text-color);
    }
  }
  .ant-switch-checked {
    background-color: rgba(138, 62, 244, 0.7) !important;
  }
  .ant-switch:focus {
    box-shadow: none;
  }
`;

const AssignScriptModal = ({
  isOpen,
  setOpen,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const [loading, setLoading] = useState(false);
  const [physicians, setPhysicians] = useState([]);
  const [selectedPhysicianId, setSelectedPhysicianId] = useState(null);
  const [physicianType, setPhysicianType] = useState("individual");
  const [selectedSpecialty, setSelectedSpecialty] = useState("");
  const { specialtyOptions } = useContext(SpecilityContext);

  const fetchPhysicians = async () => {
    if (!isOpen) return;

    try {
      setLoading(true);
      const response = await physicianService.getNonBoardMemberPhysician();
      if (response?.data) {
        setPhysicians(response.data);
      } else {
        setPhysicians([]);
        notify("error", "Failed to load physicians data");
      }
    } catch (error) {
      notify("error", "Failed to load physicians");
      setPhysicians([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhysicians();
  }, [isOpen]);

  const handleCancel = () => {
    setSelectedRowKeys([]);
    setOpen(false);
  };

  const handleAssign = async () => {
    try {
      setLoading(true);

      const payload = {
        scriptIds: selectedRowKeys,
        physicianId: physicianType === "individual" ? selectedPhysicianId : "",
        groupSpeciality: physicianType === "group" ? selectedSpecialty : "",
      };

      const res = await script.assignScriptToPhysician(payload);
      setSelectedRowKeys([]);
      setSelectedPhysicianId(null);
      setSelectedSpecialty("");
      setOpen(false);
      notify("success", "Script Assign Successfully.");
      setLoading(false);
    } catch (error) {
      console.error("Error assigning script:", error);
      setLoading(false);
    }
  };
  return (
    <Spin spinning={loading} tip="Assigning script...">
      <AddPhysicianModalWrapper
        title={
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Assign Script to Physician
            </h3>
            <span className="font-15 text-secondry">
              Select a physician to assign to the selected script.
            </span>
          </div>
        }
        open={isOpen}
        setShow={handleCancel}
        width={600}
        footer={null}
      >
        <ToggleContainer>
          <div className="toggle-label">
            <Typography.Text>Individual</Typography.Text>
            <Switch
              checked={physicianType === "group"}
              onChange={(checked) =>
                setPhysicianType(checked ? "group" : "individual")
              }
              checkedChildren="Group"
              unCheckedChildren="Individual"
            />
            <Typography.Text>Group</Typography.Text>
          </div>
        </ToggleContainer>
        {physicianType === "individual" && (
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <div>
              <Text strong style={{ marginBottom: "8px", display: "block" }}>
                Select a physician to assign:
              </Text>
              <Select
                placeholder="Select a physician"
                showSearch
                style={{ width: "100%" }}
                value={selectedPhysicianId}
                onChange={setSelectedPhysicianId}
                loading={loading}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {physicians.map((physician) => (
                  <Option
                    key={physician.id}
                    value={physician.id}
                    label={`${physician.name} : ${physician.specialty} - ${physician?.email}`}
                    style={{ borderBottom: "1px solid var(--border-color)" }}
                  >
                    {physician.name} : {physician.specialty} -  {physician?.email}
                   
                  </Option>
                ))}
              </Select>
            </div>
          </Space>
        )}

        {physicianType === "group" && (
          <Space direction="vertical" style={{ width: "100%" }} size="large">
            <div>
              <Text strong style={{ marginBottom: "8px", display: "block" }}>
                Select a group to assign:
              </Text>
              <Select
                placeholder="Select a group"
                showSearch
                style={{ width: "100%" }}
                dropdownStyle={{
                  maxHeight: 200,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
                listHeight={160}
                options={specialtyOptions}
                value={selectedSpecialty}
                onChange={setSelectedSpecialty}
                loading={loading}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              ></Select>
            </div>
          </Space>
        )}

        <Col span={24} className="d-flex justify-end gap-12 mt-20">
          <CustomSecondaryButton key="cancel" onClick={handleCancel}>
            Cancel
          </CustomSecondaryButton>
          <CustomButton
            key="assign"
            type="primary"
            loading={loading}
            onClick={handleAssign}
          >
            {loading ? "Assigning..." : "Assign Script"}
          </CustomButton>
        </Col>
      </AddPhysicianModalWrapper>
    </Spin>
  );
};

export default AssignScriptModal;
